module.exports = __webpack_public_path__ + "static/media/texture (25).2031b486.jpg";